export interface FileUpload {
  id: string;
  mimeType: string;
  blob: Blob;
}
